import { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { PageHeader, Panel, StatusPill, EmptyState } from "../../components/Bits";
import { api } from "../../lib/api";

const CAT_TINT = {
  damage: "bg-[#F5D8D8] text-[#8C3F3F]",
  late_payment: "bg-[#FBEED7] text-[#8C6D31]",
  rule_violation: "bg-[#E8C2B8] text-[#8C3F2C]",
  lost_property: "bg-[#D6E6EB] text-[#3D5C68]",
  other: "bg-[#F4F1EA] text-[#75716E]",
};

export default function StudentFines() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/fines/me").then((r) => setRows(r.data)); }, []);

  const pending = (rows || []).reduce((a, b) => a + (b.status === "pending" ? Number(b.amount) : 0), 0);

  return (
    <AppShell>
      <PageHeader overline="Charges" title="My fines" subtitle="Any damages or rule-violation charges issued to you appear here." />

      {pending > 0 && (
        <div className="bg-[#FBEED7] border border-[#E6B861] rounded-md px-5 py-3 mb-6 text-sm text-[#8C6D31]">
          You have <strong>₹ {pending.toLocaleString()}</strong> in pending fines. Please clear with the warden at the earliest.
        </div>
      )}

      <Panel>
        {rows === null ? <div className="text-sm text-warm">Loading…</div>
          : rows.length === 0 ? <EmptyState title="No fines" hint="You have a clean record. Keep it up!" />
            : (
              <ul className="divide-y divide-[#EAE5DE]">
                {rows.map((f) => (
                  <li key={f.id} className="py-4">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className={`px-2.5 py-0.5 rounded-full text-xs capitalize font-medium ${CAT_TINT[f.category] || CAT_TINT.other}`}>{f.category.replace("_", " ")}</span>
                      <StatusPill status={f.status} />
                      <span className="text-xs text-warm">{f.incident_date}</span>
                    </div>
                    <div className="flex items-start justify-between mt-2 gap-4">
                      <div>
                        <div className="font-medium text-deep">{f.title}</div>
                        {f.description && <div className="text-sm text-warm">{f.description}</div>}
                        {f.note && <div className="mt-2 text-sm bg-[#F4F1EA] border border-warm rounded-md px-3 py-2"><span className="text-xs uppercase tracking-wider text-[#A67B5B]">Warden note </span>{f.note}</div>}
                      </div>
                      <div className="font-body font-semibold text-deep text-xl whitespace-nowrap">₹ {Number(f.amount).toLocaleString()}</div>
                    </div>
                  </li>
                ))}
              </ul>
            )}
      </Panel>
    </AppShell>
  );
}
